import { Button, Result } from 'antd';
import React from 'react';

const styles = {
  content: {
    paddingTop: 60,
    fontSize: 30
  }
};

function Unathorized() {
  return (
    <div style={styles.content}>
      <Result
        status="403"
        title="401"
        subTitle="Lo sentimos, no tienes autorización para acceder a esta página"
        extra={[
          <Button
            type="primary"
            key="console"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            Ir al inicio
          </Button>
        ]}
      />
    </div>
  );
}

export default Unathorized;
